import React from 'react'
import {useSelector} from 'react-redux'
import {selectKP11SelectCartCentersNApps} from '../../../../../../app-store/kp11CartSlice'
import {CardPlanBodyStyle} from '../kp-11Link-catalog-cards-style'
import {CardPlanEntitlementsStyle} from '../../../kp-11Link-reusable-components/kp-plan-ent-checkbox-style'
import {EntCheckboxInput} from '../../../kp-11Link-reusable-components/kp-plan-ent-checkbox'
import {CardPlanItemWrapStyle} from '../../../kp-11Link-reusable-components/kp-plan-radio-input-style'
import {
  buildCartEntity,
  getItemFromCart,
  isItemAtMaxQty,
} from '../../../kp-11Link-utility/kp11-utility'
import {Button} from '@thryvlabs/maverick'
import {ProductNamePriceComponent} from '../../../../kp-card-type/product-name-price-component'

// Catalog card component
export const KP11LinkBCCardComponent = ({
  selectedCountry = 'US',
  groupKey,
  items,
  onSelectItem,
  groupCustomFields,
  onGroupCustomFieldsUpdate,
  disabled,
  addedToCart,
}) => {
  // Get selectedItem from structured cart
  const cartCentersAndApps = useSelector(selectKP11SelectCartCentersNApps)
  const selectedItem = getItemFromCart({
    cartCentersAndApps,
    groupKey,
    items,
  })
  const isMaxQtyReached = isItemAtMaxQty({
    cartCentersAndApps,
    item: items?.[0],
  })

  const availableAddons =
    (selectedItem &&
      items.find(i => i.code === selectedItem?.code)?.entitlements) ||
    []
  // const isItemAllreadyAddedandMcPro = items.find(
  //   item => item?.code === 'mc_pro-5-thryv-m2m' && item?.isAlreadyAdded,
  // )
  //   const isItemAlreadyAddedAndMcPro = items.some(
  //     item => item?.code === 'mc_pro-5-thryv-m2m' && item?.isAlreadyAdded,
  //   )

  //   const [mcData, setMcData] = useState({
  //     mcDomain: groupCustomFields?.mcDomain ?? '',
  //     isMcDomainValidated: groupCustomFields?.isMcDomainValidated ?? false,
  //     isError: groupCustomFields?.isError ?? false,
  //     helperText: groupCustomFields?.helperText ?? '',
  //     loading: groupCustomFields?.loading ?? false,
  //   })

  //   const setPartialMcData = partial => {
  //     setMcData(prev => ({...prev, ...partial}))
  //   }

  //   useEffect(() => {
  //     // if (mcData.isWebsiteURLValidated) {
  //     onGroupCustomFieldsUpdate(mcData)
  //     // }
  //   }, [mcData.mcDomain, mcData.isMcDomainValidated])

  // const [add2CartBannerStatus, setAdd2BannerStatus] = useState(addedToCart)
  // useEffect(() => {
  //   if (addedToCart) {
  //     setAdd2BannerStatus(true)
  //     setTimeout(() => {
  //       setAdd2BannerStatus(false)
  //     }, DELAY_HIDE_IN_SEC * 1000)
  //   }
  // }, [addedToCart])
  //   const isPlanDisabled = (disabled, selectedItem, item, mcData) => {
  //     const isItemAllreadyAdded = item?.isAlreadyAdded
  //     const isdisabled =
  //       disabled ||
  //       isItemAllreadyAdded ||
  //       !mcData?.isMcDomainValidated ||
  //       isItemAlreadyAddedAndMcPro
  //     return isdisabled
  //   }

  return (
    <>
      <CardPlanBodyStyle>
        {/* <div className="card-plan-subText">Select a subscription plan</div> */}
        <CardPlanItemWrapStyle wrap column={true}>
          <ProductNamePriceComponent
            cardDetail={items[0]}
            isIconRequired={false}
            isNameRequired={false}
            customFields={{}}
            country={selectedCountry}
          />
        </CardPlanItemWrapStyle>

        {/* Addons (entitlements) in checkbox */}
        {availableAddons.length > 0 && (
          <CardPlanEntitlementsStyle>
            {availableAddons.map(ent => (
              <EntCheckboxInput
                key={ent.code}
                checked={
                  selectedItem?.addons?.some(a => a.code === ent.code) || false
                }
                label={ent.name}
                disabled={ent?.disabled || ent?.isAlreadyAdded}
              />
            ))}
          </CardPlanEntitlementsStyle>
        )}

        <div className="d-flex w-100 justify-content-center">
          <Button
            variant="primary"
            disabled={disabled || isMaxQtyReached}
            onClick={() => {
              const updatedItem = buildCartEntity({
                kind: 'item',
                source: {...items[0], groupKey, section: 'centers'},
                selectedCountry,
                quantity: 1,
              })
              onSelectItem(updatedItem)
            }}
          >
            Add to Cart
          </Button>
        </div>
      </CardPlanBodyStyle>
    </>
  )
}
